import React, { useState } from 'react';
import useNotifications from '../hooks/useNotifications';
import NotificationList from './NotificationList';

/**
 * NotificationBell Component
 * 
 * Bell icon with unread count badge
 * Shows dropdown with notifications when clicked
 * 
 * Usage: Add to your Header component
 */

/**
 * NotificationBell props (all optional, defaults preserve legacy Header look):
 *   buttonClassName  full className for the outer button. Use to control
 *                    padding, hover bg, rounded, text color at once.
 *   iconSize         className for the SVG's width/height.
 */
const NotificationBell = ({
  buttonClassName = 'relative p-2 text-gray-600 hover:text-gray-900',
  iconSize = 'w-6 h-6',
}) => {
  const { unreadCount } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      {/* Bell Icon */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={buttonClassName}
      >
        <svg className={iconSize} fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
        </svg>
        
        {/* Unread Count Badge */}
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {/* Notification Dropdown */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg z-20">
            <NotificationList onClose={() => setIsOpen(false)} />
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationBell;
